import "./AboutUsSection.css";

function AboutUsSection({ eyebrow, title, text, imageSrc, imageAlt, reverse }) {
  return (
    <section
      className={
        "about-section-container fade-in-up" +
        (reverse ? " about-section-container--reverse" : "")
      }
    >
      <div className="about-section-inner">
        <div className="about-section-copy">
          {eyebrow && <span className="about-section-eyebrow">{eyebrow}</span>}
          <h2>{title}</h2>
          <p>{text}</p>
        </div>

        <div className="about-section-visual">
          <div className="about-section-image-frame hover-lift">
            {imageSrc && (
              <div className="about-section-image-wrapper">
                <img src={imageSrc} alt={imageAlt || title} />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUsSection;
